import React from 'react';
import Navbar from '../components/navbar/navbar';


const Login = () => {
  return (
    <>
    <Navbar />
    <div className="login-box-login margint">
      <p>Login</p>
      <form>
        <div className="user-box-login">
          <input required="" name="" type="text" />
          <label>Email</label>
        </div>
        <div className="user-box-login">
          <input required="" name="" type="password" />
          <label>Password</label>
        </div>
        <a href="#" className="submit-login">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          Submit
        </a>
      </form>
      <p>Don't have an account? <a href="" className="a2-login">Sign up!</a></p>
    </div>
    
    </>
  );
  
}

export default Login;
